/*
 * 文件EN: quotaChange.js,
 * 文件CN: 额度调整,
 * 创建时间: Friday, 15th May 2020 5:16:26 pm,
 * 创建人: yeungxsheng,
 * 联系邮箱: 854427332@qq.com,
 */
import request from '@/plugins/http';

/**
 * @desc 列表获取
 * @method GET
 * @param { 参数说明 详细见swagger  } 
 */
export const getListData = params => {
	return request.get('/quotaChange/list/change', params)
}

/**
 * @desc 查询申请额度调整数据详情
 * @method GET
 * @param { 参数说明 merNo: ''  } 
 */
export const fetchDetails = params => {
	return request.get(`/quotaChange/change/${params.merNo}`, params)
}

/**
 * @desc 详情 - 申请记录列表
 * @method GET
 * @param { 参数说明 merNo: ''  } 
 */
export const fetchDetailsList = params => {
	return request.get(`/quotaChange/list/change/${params.merNo}`, params)
}

/**
 * @desc 提交申请
 * @method POST
 * @param { 参数说明   } 
 */
export const TODO_Submit = params => {
	return request.post(`/quotaChange/apply`, params, { json: true })
}
